/* eslint-disable no-confusing-arrow */
/* eslint-disable multiline-ternary */
import { useState, useRef, useEffect } from 'react'
import { Controller } from 'react-hook-form'
import InputMask from 'react-input-mask'
import {
  FormFeedback,
  Input,
  Label,
  ListGroup,
  ListGroupItem,
} from 'reactstrap'

const nitMask = '9999-999999-999-9' // Ejemplo de máscara para NIT
const duiMask = '99999999-9' // Ejemplo de máscara para DUI

const SearchInput = ({
  label,
  options,
  control,
  errors,
  disabled = false,
  searchType,
  action,
  defaultvalueInput,
  database,
  itemType,
  mascara, // Nuevo campo para definir si es NIT o DUI
}) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedClient, setSelectedClient] = useState(null)
  const [isDropdownVisible, setIsDropdownVisible] = useState(false)
  const inputRef = useRef(null)
  const dropdownRef = useRef(null)

  const handleChange = (event) => {
    const sanitizedValue = event.target.value.replace(/[_-]/g, '')
    setSearchTerm(event.target.value)
    setSelectedClient(null)
    setIsDropdownVisible(true)
  }

  const handleSelectClient = (client) => {
    console.log('CLIENTE: ', client)
    setSearchTerm(client[searchType])
    setSelectedClient(client)
    setIsDropdownVisible(false)
    if (inputRef.current) {
      inputRef.current.focus() // Refocus the input after selection
    }
    action(client)
  }

  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      !inputRef.current.contains(event.target)
    ) {
      setIsDropdownVisible(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const sanitizedValue = searchTerm?.replace(/[_-]/g, '')

  //   const filteredClients = sanitizedValue.length >= 3 ? database.filter(client =>
  //     (client[searchType] && client[searchType].includes(sanitizedValue)) ||
  //     (client["dui"] && client["dui"].includes(sanitizedValue))
  // ) : [];

  const filteredClients =
    sanitizedValue?.length >= 3
      ? (database && Array.isArray(database) ? database : []).filter(
          (client) =>
            (client[searchType] &&
              client[searchType]
                .toLowerCase()
                .includes(sanitizedValue.toLowerCase())) ||
            (client['dui'] &&
              client['dui']
                .toLowerCase()
                .includes(sanitizedValue.toLowerCase()))
        ) ?? []
      : []

  const getMask = () => {
    if (mascara === 'nit') return nitMask
    if (mascara === 'dui') return duiMask
    return null
  }

  return (
    <div style={{ position: 'relative' }}>
      <Label
        className="form-label"
        for={options.id}
      >
        {label}
      </Label>
      <Controller
        id={options.id}
        name={options.name}
        control={control}
        render={({ field }) =>
          getMask() ? (
            <InputMask
              {...field}
              mask={getMask()}
              //value={searchTerm}
              onChange={(e) => {
                field.onChange(e)
                handleChange(e)
              }}
              disabled={disabled}
              onFocus={() => setIsDropdownVisible(true)} // Maneja el enfoque aquí
            >
              {(inputProps) => (
                <Input
                  {...inputProps} // Asegúrate de pasar todos los props del InputMask
                  invalid={errors[options.name] && true}
                  placeholder=""
                  required={options.required || false}
                  ref={inputRef}
                />
              )}
            </InputMask>
          ) : (
            <Input
              invalid={errors[options.name] && true}
              {...field}
              placeholder=""
              required={options.required || false}
              disabled={disabled}
              onChange={(e) => {
                field.onChange(e)
                handleChange(e)
              }}
              ref={inputRef}
            />
          )
        }
      />
      {errors[options.name] && (
        <FormFeedback>{errors[options.name]?.message}</FormFeedback>
      )}
      {isDropdownVisible && filteredClients.length > 0 && (
        <ListGroup
          style={{ position: 'absolute', zIndex: 1, width: '100%' }}
          ref={dropdownRef}
        >
          {filteredClients.map((client) => (
            <ListGroupItem
              key={client.id}
              onClick={() => handleSelectClient(client)}
              style={{ cursor: 'pointer' }}
            >
              {itemType === 'product'
                ? `${client.productCode} - ${client.productName}`
                : `${client.nit || client?.dui} - ${client.receiverName}`}
            </ListGroupItem>
          ))}
        </ListGroup>
      )}
    </div>
  )
}

export default SearchInput
